import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import { useFormFieldStore } from "../../../stores/formFieldStore";
import DBOperationsComb from "src/utils/dbOperationsComb";
import Helper from "src/utils/helper";

async function getFormPageById(id, fetchWithFields, offlineFirst = true) {
  try {
    let _pageRes;

    if (import.meta.env.VITE_USE_LOCAL_FORM_PAGE === "true") {
      const { default: localPages } = await import(
        "src/assets/forms/x_page.json"
      );
      _pageRes = { data: localPages[0], error: null };
    } else {
      _pageRes = await DBOperationsComb.getData(
        Constants.enums.TABLES_NAME_ENUM.FORM_PAGES_TABLE,
        id,
        offlineFirst
      );
    }

    if (_pageRes.error) {
      throw `Error fetching data of PAGE (ID: ${id}): ${_pageRes.error}`;
    }
    if (!fetchWithFields) return _pageRes;
    for (const fields of _pageRes.data.fields) {
      // Process fields for each field group
      for (const field of fields.group) {
        const _fieldRes = await useFormFieldStore().getFormFieldById(
          field.field_id
        );
        if (!_fieldRes) throw "Can not get field from server";
        field.fieldObj = _fieldRes;
      }
      if (fields.card_title) {
        const _fieldRes = await useFormFieldStore().getFormFieldById(
          fields.card_title.field_id
        );
        if (!_fieldRes) throw "Can not get field from server";
        fields.card_title.fieldObj = _fieldRes;
      }
      if (fields.card_body) {
        const _fieldRes = await useFormFieldStore().getFormFieldById(
          fields.card_title.field_id
        );
        if (!_fieldRes) throw "Can not get field from server";
        fields.card_body.fieldObj = _fieldRes;
      }

      if (fields.dialog_description) {
        const _fieldRes = await useFormFieldStore().getFormFieldById(
          fields.dialog_description.field_id
        );
        if (!_fieldRes) throw "Can not get field from server";
        fields.dialog_description.fieldObj = _fieldRes;
      }

      if (fields.dialog_buttons) {
        const _fieldRes = await useFormFieldStore().getFormFieldById(
          fields.dialog_buttons.field_id
        );
        if (!_fieldRes) throw "Can not get field from server";
        fields.dialog_buttons.fieldObj = _fieldRes;
      }
    }
    return Helper.deepCopy(_pageRes);
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

/**
 * form_pages rows from the server. Online: RxDB only holds the pages that have
 * been opened, so it would return a fraction of the library.
 *
 * @param {import("src/utils/dbOperationsComb/dbOperations").DBConfig} config
 * @returns {Promise<{data: Array|null, totalItems: number, error: string|null}>}
 */
async function getFormPagesList(config = {}) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.FORM_PAGES_TABLE,
        ...config
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

async function updateFormPage(data) {
  try {
    const _res = await DBOperationsComb.updateData(
      Constants.enums.TABLES_NAME_ENUM.FORM_PAGES_TABLE,
      data
    );

    if (_res.error) throw _res.error;
    return _res;
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

export default {
  getFormPageById,
  getFormPagesList,
  updateFormPage
};
